import React from 'react';
import {partial} from "underscore";
import DateTime from "react-datetime";

const renderInput = (update, props) => {
  const clear = (event) => {
    props.onChange({target: {value: ''}})
    update('')
  }
  return (
    <div className={props.className + " flex flex-row"}>
      <input {...{...props, className: props.className = 'flex flex-1 px-2 py-0.5 text-base leading-6'}} />
      <div className={props.value === '' ? "hidden" : "flex flex-1 bg-white items-center"}>
        <svg onClick={clear} height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"
        >
          <path
            d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
        </svg>
      </div>
    </div>
  )
};

const MyDateTime = ({
                      id,
                      name,
                      input_type = 'text',
                      label_string = '',
                      update,
                      ...props
                    }) => {
  const label = <label
    className="text-gray-500 mb-2"
    htmlFor={id}>{label_string}</label>;

  const input = partial(renderInput, update)

  return (
    <div className="flex-1 flex-col space-x-2"> {label}
      <DateTime
        renderInput={input}
        value={props.value}
        dateFormat={'YYYY-MM-DD'}
        onChange={(element) => update(element.format('YYYY-MM-DD'))}
        inputProps={{className: "h-9 mt-2 rounded leading-6 border-t-gray-300 border"}}
        closeOnSelect
      />
    </div>)

};

export default MyDateTime;
